import { render, staticRenderFns } from "./MtNewsModal.Style#Drawer.vue?vue&type=template&id=71b5da5b&scoped=true&"
import script from "./MtNewsModal.Style#Drawer.vue?vue&type=script&lang=js&"
export * from "./MtNewsModal.Style#Drawer.vue?vue&type=script&lang=js&"
import style0 from "./MtNewsModal.Style#Drawer.vue?vue&type=style&index=0&id=71b5da5b&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71b5da5b",
  null
  
)

export default component.exports